export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="py-12 md:py-16">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <span className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-movie-2-line text-background-50 text-lg"></i>
                </span>
                <span className="font-heading text-lg font-bold text-background-50">
                  6080影院
                </span>
              </div>
              <p className="text-sm text-background-400 leading-relaxed">
                6080影院汇集高清电影免费看和免费电视剧全集，
                高清在线影院级画质，免费影视大全无需付费，
                高清视频播放流畅不卡。
              </p>
            </div>

            <div>
              <h3 className="text-sm font-semibold text-background-50 mb-4">快速导航</h3>
              <ul className="space-y-2.5">
                {[
                  { label: '精彩专题', href: '#carousel' },
                  { label: '热播榜单', href: '#ranking' },
                  { label: '平台优势', href: '#features' },
                  { label: '常见问题', href: '#faq' },
                  { label: '关于我们', href: '#about' },
                ].map((link) => (
                  <li key={link.href}>
                    <a
                      href={link.href}
                      onClick={(e) => {
                        e.preventDefault();
                        document.querySelector(link.href)?.scrollIntoView({ behavior: 'smooth' });
                      }}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h3 className="text-sm font-semibold text-background-50 mb-4">影视分类</h3>
              <ul className="space-y-2.5">
                {['动作冒险', '喜剧搞笑', '科幻奇幻', '悬疑犯罪', '爱情剧情'].map((cat) => (
                  <li key={cat}>
                    <a
                      href="#index"
                      onClick={(e) => {
                        e.preventDefault();
                        document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' });
                      }}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {cat}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h3 className="text-sm font-semibold text-background-50 mb-4">合作伙伴</h3>
              <p className="text-sm text-background-500 leading-relaxed mb-4">
                更多优质合作伙伴即将入驻，敬请期待
              </p>
              <h3 className="text-sm font-semibold text-background-50 mb-3 mt-6">关注我们</h3>
              <div className="flex gap-3">
                {[
                  { icon: 'ri-wechat-line', label: '微信' },
                  { icon: 'ri-weibo-line', label: '微博' },
                  { icon: 'ri-bilibili-line', label: 'B站' },
                ].map((social) => (
                  <a
                    key={social.label}
                    href="#footer"
                    onClick={(e) => e.preventDefault()}
                    className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-400 hover:bg-primary-500 hover:text-background-50 transition-all cursor-pointer"
                    aria-label={social.label}
                  >
                    <i className={`${social.icon} text-base`}></i>
                  </a>
                ))}
              </div>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-background-500">
              &copy; 2026 6080影院 - 高清电影免费看 | 免费电视剧全集 高清在线影院 免费影视大全
            </p>
            <div className="flex gap-4 text-xs text-background-500">
              <a href="#footer" onClick={(e) => e.preventDefault()} className="hover:text-primary-400 transition-colors cursor-pointer">服务条款</a>
              <a href="#footer" onClick={(e) => e.preventDefault()} className="hover:text-primary-400 transition-colors cursor-pointer">隐私政策</a>
              <a href="#contact" onClick={(e) => { e.preventDefault(); document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' }); }} className="hover:text-primary-400 transition-colors cursor-pointer">联系我们</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}